export const FeatureGamePage = {
  LabelSponsoredAd: 'Label.SponsoredAd',
  LabelNoSearchResults: 'LabelNoSearchResults',
  LabelPlayingOnePlusUsersWithComma: 'LabelPlayingOnePlusUsersWithComma',
  LabelPlayingOneUser: 'LabelPlayingOneUser'
};

export const CommonGameSorts = {
  LabelApiError: 'Label.ApiError',
  LabelGames: 'Label.Games'
};

export const FeaturePlacesList = {
  ActionSeeAll: 'Action.SeeAll'
};

export default {
  CommonGameSorts,
  FeatureGamePage,
  FeaturePlacesList
};
